import { createContext, useContext } from 'react';

export interface ModalConfig {
  close?: () => void;
}

const defaultContext = {};

export const ModalContext = createContext<ModalConfig>(defaultContext);

export const useModalContext = (): ModalConfig => useContext<ModalConfig>(ModalContext);
